import styled from "styled-components";

export const PageBackground = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
`;

export const PageShell = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ProductListCard = styled.div`
  background: ${(props) => props.theme.tokens.colors.surface};
  border-radius: ${(props) => props.theme.tokens.radii.lg}px;
  margin: 0 14px 14px;
  padding: 4px 14px;
  box-shadow: ${(props) => props.theme.tokens.shadows.card};
  border: 1px solid ${(props) => props.theme.tokens.colors.softBg};
`;
